import { PeriUp } from "./PeriUp";

export default PeriUp;
